<div [class]="fieldClasses">
  <label [for]="fieldId" class="n-field-label">
    {{ label }}
    @if (required) {
    <span class="n-required-indicator">*</span>
    }
  </label>

  <div class="n-field-input-container">
    @if (iconPrefix) {
    <div class="n-input-with-icon">
      <i [class]="iconPrefix" class="n-field-icon"></i>
      <ng-content></ng-content>
    </div>
    } @else {
    <ng-content></ng-content>
    }
  </div>

  @if (helpText && !hasError) {
  <small class="n-field-help">{{ helpText }}</small>
  }

  @if (maxLength) {
  <small
    class="n-field-counter"
    [class.n-field-counter-warn]="isNearCharacterLimit"
    [class.n-field-counter-limit]="currentLength >= maxLength"
  >
    {{ 'GLOBAL.FORM_FIELD.CONTADOR' | translate: { atual: currentLength, maximo: maxLength, restantes: remainingCharacters } }}
  </small>
  }

  <!-- Mensagens de erro -->
  @if (showError('required')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.OBRIGATORIO' | translate: { label: label } }}
  </small>
  } @if (showError('email')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.EMAIL_INVALIDO' | translate }}
  </small>
  } @if (showError('minlength')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.MINLENGTH' | translate: { min: control?.errors?.['minlength']?.requiredLength } }}
  </small>
  } @if (showError('maxlength')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.MAXLENGTH' | translate: { max: control?.errors?.['maxlength']?.requiredLength } }}
  </small>
  } @if (showError('pattern')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.FORMATO_INVALIDO' | translate }}
  </small>
  } @if (showError('min')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.VALOR_MINIMO' | translate: { min: control?.errors?.['min']?.min } }}
  </small>
  } @if (showError('max')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.VALOR_MAXIMO' | translate: { max: control?.errors?.['max']?.max } }}
  </small>
  }

  <!-- Erro genérico para outros tipos de validação -->
  @if (hasError && !showError('required') && !showError('email') &&
  !showError('minlength') && !showError('maxlength') && !showError('pattern') &&
  !showError('min') && !showError('max')) {
  <small class="n-field-error-message">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'GLOBAL.FORM_FIELD.ERRO_VALIDACAO' | translate: { label: label } }}
  </small>
  }
</div>
